import {
    Component, Mixins, Emit, Watch,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import { digits } from '@nodes/helpers/number';
import {
    YCol, YContainer, YIcon, YMenu, YRow,
} from '@components/index';

import Props from './props';

@Component({
    components: {
        YContainer,
        YMenu,
        YIcon,
        YRow,
        YCol,
    },
})

/**
 * @name Header
 */
export default class Header extends Mixins(HybridMixin, Props, CoreMixin) {
    mobileMenu: boolean = false;
    isLogin: boolean = false;
    search = null;
    user = null;
    avatarImg = null;
    wallets = null;
    categories = [];
    refactorMenu = null;
    menuItems=[];

    digits = digits;

    /**
     * Change route locale
     *
     * @param {object} locale - Locale object
     */
    changeLocale(locale: { [k: string]: any }): void {
        this.$router.replace({ name: 'home', params: { locale: locale.value } });
    }

    /**
     * Do search
     */
    doSearch() {
        if (this.search) {
            this.$router.replace({ name: `${this.searchType}`, query: { search_front: this.search } }).catch((err) => {
                this.handleError(err);
            });
        }
    }

    /**
     * Open mobile menu
     */
    openMenu() {
        this.mobileMenu = true;
        const element = document.querySelector('.l-default');
        if (element) {
            element.classList.add('menu-open');
        }
    }

    /**
     * Open mobile menu
     */
    closeMenu() {
        this.mobileMenu = false;
        const element = document.querySelector('.l-default');
        if (element) {
            element.classList.remove('menu-open');
        }
    }

    /**
     * Close mobile menu on change route
     */
    @Watch('$route', { immediate: true, deep: true })
    onChangeRoute() {
        this.closeMenu();
        if (this.$route.query.logout) {
            this.$store.dispatch('auth/logout');
            this.isLogin = false;
        }
    }

    /**
     * Emit cart click event on callback.
     *
     * @param {object} e - Event of the click
     * @returns {*}
     */
    @Emit('cartEvent')
    clickCart(e: Record<string, any>): any {
        // eslint-disable-line @typescript-eslint/no-explicit-any
        return e;
    }

    /**
     * Emit login click event on callback.
     *
     * @param {object} e - Event of the click
     * @returns {*}
     */
    @Emit('loginEvent')
    clickLogin(e: Record<string, any>): any {
        // eslint-disable-line @typescript-eslint/no-explicit-any
        return e;
    }

    /**
     * @inheritDoc
     */
    created() {
        if (this.$store.getters['auth/isLoggedIn']) {
            this.isLogin = true;
        }
        if (this.$store.getters['auth/isLoggedIn']) {
            this.fetch();
            this.fetchUserWallets();
        }
        if (this.productCategories) {
            this.fetchProductCategory();
        }
    }

    /**
     * fetch user info
     *
     * @returns {Promise}
     */
    fetch() {
        return this.$services.Person.userEditProfileFetch()
            .then((response) => {
                const avatar = response.data.metadata;
                this.user = response.data.results;
                this.avatarImg = avatar.avatar.resource['0'];
            })
            .catch((error) => {
                this.handleError(error);
            });
    }

    /**
     * Fetch User Wallets
     *
     * @returns {*}
     */
    fetchUserWallets() {
        this.$wait.start('fetch-wallets');
        return this.$services.Wallet.myWallets()
            .then((response) => {
                this.wallets = response.data.results;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                this.$wait.end('fetch-wallets');
            });
    }

    /**
     * Fetch product categories
     *
     * @returns {Promise}
     */
    fetchProductCategory() {
        return this.$services.Tagging.labels({
            slug: this.categorySlug,
        })
            .then((response) => {
                const parents = response.data.results.filter((item) => !item.parent_id);
                parents.forEach((element) => {
                    const children = response.data.results.filter((item) => item.parent_id === element.id);
                    this.categories.push({ ...element, children });
                });

                // Find Category menu-item
                const productsLink = this.menu.find((item) => item.link.includes(this.categoryRouteName));
                const productsIndex = this.menu.findIndex((item) => item.link.includes(this.categoryRouteName));

                const refactorCategories = [];

                // Refactor tags for menu-item
                this.categories.forEach((element) => {
                    const newEl = {
                        active  : element.activeness,
                        external: 0,
                        text    : element.title,
                        link    : `${productsLink.link}/category/${element.url_encode}`,
                        ...element,
                    };
                    delete newEl.activeness;
                    delete newEl.title;

                    const title = {
                        active  : element.activeness,
                        external: 0,
                        text    : this.$t('general.all_products') + element.title,
                        link    : `${productsLink.link}/category/${element.url_encode}`,
                    };


                    const newChildList = [];
                    newChildList.push(title);


                    // Refactor tags for children of menu-item
                    newEl.children.forEach((child) => {
                        const newChild = {
                            active  : child.activeness,
                            external: 0,
                            text    : child.title,
                            link    : `${productsLink.link}/category/${child.url_encode}`,
                            ...child,
                        };
                        delete newChild.activeness;
                        delete newChild.title;
                        // Create news list of children
                        newChildList.push(newChild);
                    });

                    // Set new children list to menu-item
                    newEl.children = newChildList;

                    refactorCategories.push(newEl);
                });

                // Set new element of menu-item to products_menu_item
                productsLink.children = refactorCategories;

                this.refactorMenu = this.menu;
                this.refactorMenu[productsIndex] = productsLink;
                this.menuItems = this.menu;
            })
            .catch((error) => {
                this.handleError(error);
            });
    }

    /**
     * Add class to body after mouse enter
     */
    menuMouseEnter() {
        if (window.screen.width > 992) {
            document.querySelector('.r-header__menu--main li.has-child').addEventListener('mouseenter', () => {
                document.querySelector('body').classList.add('hide-body');
            });
        }
    }

    /**
     * remover class to body after mouse leave
     */
    menuMouseLeave() {
        document.querySelector('.r-header__menu--main li.has-child').addEventListener('mouseleave', () => {
            document.querySelector('body').classList.remove('hide-body');
        });
        document.querySelector('.r-header').addEventListener('mouseleave', () => {
            document.querySelector('body').classList.remove('hide-body');
        });
    }

    /**
     * Return link number
     *
     * @param {string | number} tel
     * @param {string} type - type of number
     * @returns {string}
     */
    numberLink(tel: number, type: string = 'tel'): string {
        let num = this.digits(tel, 'en');
        if (String(num)[0] === String(0)) {
            num = String(num).slice(1);
        }

        num = String(num).replace('-', '');
        return `${type}:+98${this.digits(parseInt(num.toString(), 10), 'en')}`;
    }
}
